import React, {Component} from 'react';
import { Switch, FormControlLabel } from '@material-ui/core';
import SaveSureDialog from './SaveSureDialog';
import Button from '@material-ui/core/Button';
import PopoverItem from './PopoverItem'
import { connect } from 'react-redux';
import { NotificationManager, NotificationContainer } from 'react-notifications';
import selectors from '../../../reducers/selectors';
import { updateShopBusyAction } from '../../../actions/ShopBusy';

class ShopBusy extends Component {

    constructor(props) {
        super(props)

        if (props.refreshInfo) {
            props.refreshInfo();
        }

        this.state = {
            isBusy: props.shop && typeof props.shop.isBusy !== 'undefined' ? props.shop.isBusy : false,
            isDialogOpen: false
        }

        this.stateCopy = Object.assign(this.state, {})

        // No need for TODO: Replace with actual action to get shop busy status
        // Now using props.shop.isBusy

        this.onSaveClicked = this.onSaveClicked.bind(this)
        this.handleDialogClose = this.handleDialogClose.bind(this)
        this.onDialogYesClicked = this.onDialogYesClicked.bind(this)
        this.isStateDifferent = this.isStateDifferent.bind(this)
    }

    componentDidUpdate(prevProps) {
        if (
            this.props.shop &&
            typeof this.props.shop.isBusy !== 'undefined' &&
            prevProps.shop &&
            this.props.shop.isBusy !== prevProps.shop.isBusy
        ) {
            this.setState({ isBusy: this.props.shop.isBusy });
        }
    }

    onSwitchChange = (checked) => {
        this.setState({isBusy: checked})
    }

    onSaveClicked() {
        this.setState({
            isDialogOpen: true
        })
    }

    handleDialogClose() {
        this.setState({isDialogOpen: false})
    }

    onDialogYesClicked() {
        this.handleDialogClose()
        const paramsObj = Object.assign({}, this.state, {
            shopId: this.props.shopId,
            isBusy: this.state.isBusy
        })

        this.props.updateShopBusyAction(paramsObj,
            (resp) => {
                if(resp.val !== 'False') {
                    NotificationManager.success("The new settings are now saved in CoffeePass!", "Success")
                    this.stateCopy = Object.assign(this.state, {})
                    this.setState(this.state)
                    if (this.props.refreshInfo) {
                        this.props.refreshInfo();
                    }
                } else {
                    NotificationManager.error("There was an Error saving the shop busy status. If the problem persists contact support@coffeepass.io.", "Error Saving shop busy status!", 9000)
                }
            },
            (error) => {
                NotificationManager.error("Error: " + error + ". If the problem persists contact support@coffeepass.io.", "Error saving Settings!", 9000)
            })
    }

    isStateDifferent() {
        for(var key in this.state) {
            var val = this.state[key]
            var copyVal = this.stateCopy[key]
            if(val != copyVal) {
                return true
            }
        }
        return false
    }

    render(props) {
        return(
            <form className="row" autoComplete="off">
                <div className="col-md-12 col-12">
                    <FormControlLabel
                        control={
                            <Switch color="primary"
                                classes={{
                                    checked: 'text-primary',
                                    bar: 'bg-primary',
                                }}
                                checked={this.state.isBusy}
                                onChange={(event, checked) => this.onSwitchChange(checked)}
                            />
                        }
                        label={this.state.isBusy ? "Shop is Currently Busy" : "Shop is Currently Not Busy"} />
                    <PopoverItem 
                        placement={'right'} 
                        id={'busyinfoId'}
                        title="What is This?"
                        text="You can switch ON/OFF shop busy status at anytime to let customers know if your shop is currently busy." />
                </div>
                <div className="col-md-12 col-12" style={styles.buttonContainer}>
                    <Button
                        variant="raised"
                        color="primary"
                        className="jr-btn"
                        disabled={!this.isStateDifferent()}
                        onClick={this.onSaveClicked}>
                        Save
                    </Button>
                </div>
                <SaveSureDialog
                    isDialogOpen= {this.state.isDialogOpen}
                    handleClose={this.handleDialogClose}
                    onYesClicked={this.onDialogYesClicked}
                    onNoClicked={this.handleDialogClose}
                    dialogDataToSave="shop busy status"
                    />
                <NotificationContainer />
            </form>
            )
    }
}

const styles = {
    buttonContainer: {
        display: 'flex', 
        justifyContent: 'flex-end'
    }
}
const mapStateToProps = state => {
    return {
        shopId: selectors(state).shopId,
        shop: selectors(state).shop
    }
}
const actionCreators = {
    updateShopBusyAction
}
export default connect(
    mapStateToProps,
    actionCreators
)(ShopBusy); 